import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

const ckClass = (val, isCheck) => {
  if (isCheck) return val === '✓' ? 'ok' : 'no';
  // numeric/yearly display
  return val === '✓' ? 'ok' : (val === '✗' ? 'no' : 'warn');
};

const readinessColor = (r) => r >= 80 ? 'var(--ok)' : r >= 50 ? 'var(--warn)' : 'var(--bad)';

export default function Pipeline() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    let alive = true;
    api.get("/stats/pipeline")
      .then(({data}) => { if (alive) setRows(data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  return (
    <div data-testid="view-pipeline">
      <div className="topbar">
        <div>
          <h1 className="pg-title">Promotion Pipeline</h1>
          <div className="pg-sub">Faculty approaching eligibility, with NMC criteria checklist per person</div>
        </div>
      </div>
      <div className="card">
        <table className="data">
          <thead>
            <tr>
              <th>Faculty</th><th>Current</th><th>Targeting</th>
              <th style={{textAlign:'center'}}>Post-PG</th>
              <th style={{textAlign:'center'}}>In Role</th>
              <th style={{textAlign:'center'}}>Pubs</th>
              <th style={{textAlign:'center'}}>MET</th>
              <th style={{textAlign:'center'}}>BMR</th>
              <th style={{textAlign:'right'}}>Readiness</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.faculty_id} style={{cursor:'pointer'}} onClick={() => navigate(`/profile/${r.faculty_id}`)}>
                <td>
                  <span className="dept-name">Dr. {r.full_name}</span><br/>
                  <span style={{fontFamily:'var(--mono)', fontSize:10, color:'var(--text-3)'}}>{r.ssmch_id}</span>
                </td>
                <td>{r.current}</td>
                <td>{r.target}</td>
                <td className="num"><span className={`ck ${ckClass(r.display.post_pg)}`}>{r.display.post_pg}</span></td>
                <td className="num"><span className={`ck ${ckClass(r.display.in_role)}`}>{r.display.in_role}</span></td>
                <td className="num"><span className={`ck ${ckClass(r.display.pubs)}`}>{r.display.pubs}</span></td>
                <td className="num"><span className={`ck ${ckClass(r.display.met, true)}`}>{r.display.met}</span></td>
                <td className="num"><span className={`ck ${ckClass(r.display.bmr, true)}`}>{r.display.bmr}</span></td>
                <td style={{textAlign:'right', fontFamily:'var(--mono)', fontWeight:500, color: readinessColor(r.readiness)}}>{r.readiness}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
